module.exports = __webpack_public_path__ + "img/mechanic.db1c2c47.png";